export default "__VITE_ASSET__BjmsuI_v__"